import { ResourceCentrePageCategoryItem } from '../../../types';

export const translations: ResourceCentrePageCategoryItem = {
  title: 'Credit/Debit Cards',
  content: [
    'Losing your payment cards can be stressful and inconvenient, leaving you without access to funds and open to',
    'fraud. Here are some immediate steps you can take to recover from lost payment cards and get yourself back',
    'on track:',

    '<ul>',

    '<li><strong>Report lost or stolen financial cards immediately</strong><br />',
    'Report your credit and debit cards lost or stolen as soon as you realize they are missing to prevent unauthorized',
    'charges to your cards. OnGuard subscribers can go online or call customer service representatives who will ensure',
    'your lost or stolen credit and debit cards are promptly cancelled.<br />',
    '</li>',

    '<li><strong>Update pre-authorized payments</strong><br />',
    'Pre-authorized payments from your bank account (such as rent and utilities) should not be affected.',
    'Pre-authorized payments to your cards (recurring payments for services such as Netflix that show up on your',
    'monthly statements) are not automatically transferred to new cards. Contact these services to update your billing',
    'information to ensure your service remains uninterrupted.',
    '</li>',

    '<li><strong>Update payment information saved online</strong><br />',
    'Update your payment information on any places it may be saved, such as Amazon or Apple Pay, to ensure you can',
    'continue to make seamless purchases.',
    '</li>',

    '</ul>'
  ].join('\n')
};
